module.exports = __webpack_public_path__ + "static/img/color.2e76c66d.png";